<div>
    <h2 style="margin-bottom: 5px;">{{'newOrder.hechtProposal.tabs.centralRadius.title' | translate}}</h2>
</div>

<div>
    <form [formGroup]="form">
        <div class="d-flex">
            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.RadiusFlach' | translate" matTooltipPosition="above">{{"common.features.RadiusFlach" | translate}}<span class="span-label-required"></span>
                    <input formControlName="radiusFlach" class="form-control parameter-input" (blur)="setValueWithFormat('RadiusFlach', 'radiusFlach')"
                    [ngClass]="{required: true, error: form.get('radiusFlach').errors && (form.get('radiusFlach').touched || (form.get('radiusFlach').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(4.5,15)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.RadiusFlachDegree' | translate" matTooltipPosition="above">{{"common.features.RadiusFlachDegree" | translate}}<span class="span-label-required"></span>
                    <input formControlName="radiusFlachDegree" class="form-control parameter-input" (blur)="setValueWithFormat('RadiusFlachDegree', 'radiusFlachDegree')"
                    [ngClass]="{required: true, error: form.get('radiusFlachDegree').errors && (form.get('radiusFlachDegree').touched || (form.get('radiusFlachDegree').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(0,179)" matTooltipPosition="above">
                </div>
            </div>
        </div>

        <div class="d-flex">
            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.RadiusSteil' | translate" matTooltipPosition="above">{{"common.features.RadiusSteil" | translate}}<span class="span-label-required"></span>
                    <input formControlName="radiusSteil" class="form-control parameter-input" (blur)="setValueWithFormat('RadiusSteil', 'radiusSteil')"
                    [ngClass]="{required: true, error: form.get('radiusSteil').errors && (form.get('radiusSteil').touched || (form.get('radiusSteil').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(4.5,15)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.RadiusSteilDegree' | translate" matTooltipPosition="above">{{"common.features.RadiusSteilDegree" | translate}}
                    <input formControlName="radiusSteilDegree" class="form-control parameter-input" [attr.disabled]="true" placeholder="-"/>
                </label>
            </div>
        </div>

        <div class="d-flex">
            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.Eccentricity' | translate" matTooltipPosition="above">{{"common.features.Eccentricity" | translate}}<span class="span-label-required"></span>
                    <input formControlName="eccentricity" class="form-control parameter-input" (blur)="setValueWithFormat('Eccentricity', 'eccentricity')"
                    [ngClass]="{required: true, error: form.get('eccentricity').errors && (form.get('eccentricity').touched || (form.get('eccentricity').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(-2,2)" matTooltipPosition="above">
                </div>
            </div>
            <button mat-flat-button color="primary" class="action-button" (click)="openEccentricityDialog()">{{"newOrder.hechtProposal.tabs.centralRadius.eccentricityModalButton" | translate}}</button>
        </div>

        <div class="d-flex">
            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.HHDia' | translate" matTooltipPosition="above">{{"common.features.HHDia" | translate}}<span class="span-label-required"></span>
                    <input formControlName="hhDia" class="form-control parameter-input" (blur)="setValueWithFormat('HHDia', 'hhDia')"
                    [ngClass]="{required: true, error: form.get('hhDia').errors && (form.get('hhDia').touched || (form.get('hhDia').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(9,14)" matTooltipPosition="above">
                </div>
            </div>
        </div>

        <div class="d-flex">
            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.KCStadium' | translate" matTooltipPosition="above">{{"common.features.KCStadium" | translate}}<span class="span-label-required"></span>
                    <input formControlName="kCStadium" class="form-control parameter-input" (blur)="setValueWithFormat('KCStadium', 'kCStadium')"
                    [ngClass]="{required: true, error: form.get('kCStadium').errors && (form.get('kCStadium').touched || (form.get('kCStadium').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(0,3)" matTooltipPosition="above">
                </div>
            </div>
        </div>

        <div class="d-flex">
            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.TorizitatCentral' | translate" matTooltipPosition="above">{{"common.features.TorizitatCentral" | translate}}
                    <input formControlName="torizitatCentral" class="form-control parameter-input" [attr.disabled]="true" placeholder="-"/>
                </label>
                <div class="info" [style.visibility]="'hidden'">
                    <img src="assets/img/icons/info.svg">
                </div>
            </div>

            <div class="d-flex central-radius-parameter">
                <label [matTooltip]="'common.hints.Astigmat' | translate" matTooltipPosition="above">{{"common.features.Astigmat" | translate}}
                    <input formControlName="astigmat" class="form-control parameter-input" [attr.disabled]="true" placeholder="-"/>
                </label>
            </div>
        </div>

        <h2 style="margin-bottom: 5px; margin-top: 20px;">{{"newOrder.finalLens.lensType.title" | translate}}</h2>
        <mat-radio-group formControlName="lensType">
            <mat-radio-button [value]="LensType.HARD" class="mat-radio-button-first">{{"newOrder.finalLens.lensType.hard" | translate}}</mat-radio-button>
            <mat-radio-button [value]="LensType.SOFT">{{"newOrder.finalLens.lensType.soft" | translate}}</mat-radio-button>
        </mat-radio-group>

        <app-validation-error [form]="form"></app-validation-error>

    </form>
</div>
